import {
	ImageService,
	ObserverService,
	ApiService,
	ListingModalService,
} from '@DavisDigital/davisdigitalfrontend.module';

import {
	ContentModuleTypes,
	ContentModuleSubTypes,
	EVENTS,
	ContentModals,
	Lesson,
} from '@DavisDigital/interfaces';

class ContentModuleController {
	
	public alignItemsValue: string;
	public contentModule;
	public emailAddress: string;
	public emailBody: string;
	public emailSubject: string;
	public eventId;
	public fromEmailAddress: string;
	public fromName: string;
	public image;
	public imageIDs = [];
	public images = [];
		
	public bookList : Array<any>=[];
	public bookExists: string;

	public lessonId;
	public lesson: Lesson;
	public portfolioPageId;
	public portfolioPage;

	public position;

	public saveEvent;
	public setEvent;

	public trustedBodyHTML;
	public type;

	//initiates the iframe, right now we've configured to load iframe when module loads
	public videoPlaying = true;

	public viewType;
	
	public slatwall:any;
	
	// @ngInject
	constructor(
		public imageService    : ImageService,
		public observerService : ObserverService,
		public apiService	   : ApiService,
		public $location	   : ng.ILocationService,
		public $sce     	   : ng.ISCEService,
		public $timeout		   : ng.ITimeoutService,
		public listingModalService: ListingModalService,
		public ModalService
	){}
	
	public $onInit = () => {
		
		this.observerService.attach(this.setViewType, 'viewType');
		
		this.viewType = this.$location.search().view;
		
		if(this.lessonId != null){
			this.eventId = this.lessonId;
			this.getBookList();
		}

		if (this.portfolioPageId != null) {
			this.eventId = this.portfolioPageId;
		}

		//temporarily setting this as the default this field should always be passed
		if (this.saveEvent == null) {
			this.saveEvent = 'savePortfolioPage';
		}
		
		if(this.type == null){
			if(this.lessonId?.length == 32){
				
				this.type = 'lesson';
				
			} else if (this.portfolioPageId?.length == 32){
				
				this.type = 'portfolioPage';
			
			} else if (this.$location.search().lessonType != null){
				this.type = 'lesson';
			} else { 
				
				this.type = 'portfolioPage';	
			}
		}

		this.observerService.attach(this.updateContentModule, EVENTS.UPDATE_CONTENT_MODULES);

		this.updateContentModule();
	}
	
	public setViewType = (viewType) =>{
		this.viewType = viewType;
	}
	
	public $onDestroy = () =>{
		this.contentModule = null; 
	}
	
	public getBookList = () =>{
		this.apiService.request('davisdigital:api.getBooksForAccount')
		.then(({data})=>{
			if(data.data && data.data.length){
				for(let book of data.data){
					let bookListBook = {};

					if( book.studentEdition ){
						book.name = book.title + ' (Student Book)';
						book.value = book.studentEdition.bookID;
						
						this.bookList.push({...book});
					}
					
					if( book.teacherEdition ){
						book.name = book.title + ' (Teacher Edition)';
						book.value = book.teacherEdition.bookID;
						this.bookList.push(book);
					}
				}
				
			}
		})
	}
	
	public bookCheck = (contentModule: any) => {
		
		for(var i=0; i<this.bookList.length; i++){
				if (this.contentModule.bookLesson_book_bookID == this.bookList[i].teacherEdition.bookID || 
					this.contentModule.bookLesson_book_bookID == this.bookList[i].studentEdition.bookID
					) {
					this.bookExists = this.contentModule.bookLesson_book_bookID;
					break; 
				}
			}
	}
	
	
	public updateContentModule = () =>{
		
		if(this.contentModule == null) return;
		
		this.$timeout(
			()=>{
				this.image = null;	
			}
		);
		
		this.trustedBodyHTML = null;

		if (this.contentModule.contentModuleImages) {
			this.images = this.contentModule.contentModuleImages;
		}

		if (
			this.contentModule.primaryContentModuleImage_image_imageID &&
			this.contentModule.primaryContentModuleImage_image_imageID.trim().length === 32
		) {
			this.$timeout(() => {
				
				this.image = this.imageService.getImage(
					this.contentModule.primaryContentModuleImage_image_imageID,
				);
				
				if(this.image){
					this.image.caption = this.contentModule.primaryContentModuleImage_caption;
				}
			});
		}
		
		if( this.contentModule.alignment?.trim().length > 0 ){
			
			switch(this.contentModule.alignment){
				case 'Left': {
					this.alignItemsValue = 'flex-start';
					break;
				}
				case 'Right': {
					this.alignItemsValue = 'flex-end';
					break;
				}
				default: {
					this.alignItemsValue = 'center';
					break;
				}
			}
			
		}

		if (this.contentModule.bodyHTML.length) {
			//we are trusting because we validate iframe on save
			this.trustedBodyHTML = this.$sce.trustAsHtml(this.contentModule.bodyHTML);
		}
	};

	public downloadFile = () => {
		if (this.contentModule.contentModuleType_systemCode !== ContentModuleTypes.BUTTON) {
			return;
		}

		var anchor = document.createElement('a');
		anchor.href =
			'?slatAction=davisdigital:api.getContentModuleFile&contentModuleID=' +
			this.contentModule.contentModuleID;
		anchor.target = '_blank';
		document.body.appendChild(anchor);
		anchor.click();
		document.body.removeChild(anchor);
	};

	public launchEditModal = (modalComponent: ContentModals) => {
		let bindings: any = {
			contentModule: this.contentModule,
			position: this.position,
		};
		if (this.lessonId?.length) {
			(bindings.type = 'lesson'), (bindings.lessonId = this.lessonId);
		} else if (this.portfolioPageId?.length) {
			(bindings.type = 'portfolioPage'), (bindings.portfolioPageId = this.portfolioPageId);
		}
		this.ModalService.showModal({
			component: modalComponent,
			bodyClass: 'angular-modal-service-active',
			bindings: bindings,
			preClose: (modal) => {
				modal.element.modal('hide');
				this.ModalService.closeModals();
			},
		}).then((modal) => {
			//it's a bootstrap element, use 'modal' to show it
			modal.element.modal('show');
			modal.close.then((result) => {});
		});
	};

	public toggleEdit = () => {
		this.contentModule.editing = !this.contentModule.editing;

		if (this.contentModule.contentModuleType_systemCode === ContentModuleTypes.VIDEO) {
			this.launchEditModal(ContentModals.ADD_VIDEO);
		}

		if (this.contentModule.contentModuleType_systemCode === ContentModuleTypes.BUTTON) {
			this.launchEditModal(ContentModals.ADD_BUTTON);
		}

		if (this.contentModule.contentModuleType_systemCode === ContentModuleTypes.IMAGE) {
			this.launchImageModal(ContentModuleTypes.IMAGE);
		}

		if (!this.contentModule.editing) {
			this.notifySave();
		}
	};

	public toggleVideoPlay = () => {
		this.videoPlaying = !this.videoPlaying;
	};

	public toggleSplitImage = () => {
		this.contentModule.splitImageLeftFlag = !this.contentModule.splitImageLeftFlag;

		if (this.contentModule.contentModuleID.length) {
			this.notifySave();
		}
	};
	
	public launchImageModal = (contentModuleType = 'cmtSplit') => {
		let bindings: any = {
			contentModule: this.contentModule,
			contentModuleType: contentModuleType,
		};
		if (this.lessonId?.length) {
			bindings.type = 'lesson', bindings.lessonId = this.lessonId;
		} else if (this.portfolioPageId?.length) {
			bindings.type = 'portfolioPage', bindings.portfolioPageId = this.portfolioPageId;
		} else {
			bindings.type = 'unknown';
		}
		
		bindings.saveEvent = this.saveEvent;
		bindings.setEvent = this.setEvent;
		bindings.type = this.type;

		this.ModalService.showModal({
			component: 'imageUploadModal',
			bodyClass: 'angular-modal-service-active',
			bindings: bindings,
			preClose: (modal) => {
				modal.element.modal('hide');
				this.ModalService.closeModals();
			},
		}).then((modal) => {
			//it's a bootstrap element, use 'modal' to show it
			modal.element.modal('show');
			modal.close.then((result) => {});
		});
	}
	
	public launchSlideshowModal = (contentModuleImage?, image?) =>{
		let bindings:any = {
			contentModule: this.contentModule
		}
		
		if(contentModuleImage != null){
			bindings.contentModuleImage = contentModuleImage;
		}
		
		if(image != null){
			bindings.image = image;
		}
		
		if(this.lessonId?.length){
			bindings.type = 'lesson',
			bindings.lessonId = this.lessonId
		}else if(this.portfolioPageId?.length){
			bindings.type = 'portfolioPage',
			bindings.portfolioPageId = this.portfolioPageId
		}
		
		this.ModalService.showModal({
			component: 'imageGallerySlideshowModal',
			bodyClass: 'angular-modal-service-active',
			bindings: bindings,
			preClose: (modal) => {
				modal.element.modal('hide');
				this.ModalService.closeModals();
			},
		}).then((modal) => {
			//it's a bootstrap element, use 'modal' to show it
			//modal.element.modal('show');
			modal.close.then((result) => {});
		});
		
		
	}
	
	public launchBookView = () =>{
		this.ModalService.showModal({
			component: 'bookPreview',
			bodyClass: 'angular-modal-service-active',
			bindings: {
				bookID: this.contentModule.bookLesson_book_bookID,
				pageNumber: this.contentModule.bookLesson_pageNumber,
				previewFlag: false,
			},
			preClose: (modal) => {
				modal.element.modal('hide');
				this.ModalService.closeModals();
			},
		}).then((modal) => {
			//it's a bootstrap element, use 'modal' to show it
			modal.element.modal('show');
			modal.close.then((result) => {});
		});
	};

	public deleteContentModule = () => {
		let notifyId = this.lessonId?.length ? this.lessonId : this.portfolioPageId;

		let args = {
			contentModule: this.contentModule,
			position: this.position,
		};

		if (this.eventId != null && this.eventId.length === 32) {
			this.observerService.notifyById(EVENTS.DELETE_CONTENT, this.eventId, args);
		} else {
			this.observerService.notify(EVENTS.DELETE_CONTENT, args);
		}
	};

	public notifySave = () => {
		let args = {
			contentModule: this.contentModule,
		};

		if (this.eventId != null && this.eventId.length === 32) {
			this.observerService.notifyById(this.saveEvent, this.eventId, args);
		} else {
			this.observerService.notify(this.saveEvent, args);
		}
	};

	public sendContactForm = () => {

		var data: any = {
			fromName: this.fromName,
			fromEmailAddress: this.fromEmailAddress,
			emailSubject: this.emailSubject,
			emailBody: this.emailBody,
			contentModuleID: this.contentModule.contentModuleID,
		};
		this.apiService.request('davisdigital:api.sendContactForm', data).then((result) => {
			if (result.data) {
				let resultData = result.data;
				if (resultData.successfulActions && resultData.successfulActions.length) {
					this.contentModule.sent = true;
				}
			}
		});
	};

	public launchCopyContentModal = () => {
		this.listingModalService.launchCopyContentModal(this.contentModule, this.lesson, this.portfolioPage);
	};
}

class ContentModule implements ng.IDirective {
	public restrict: string = 'E';
	public scope: boolean = true;

	public bindToController: any = {
		saveEvent: '@?',
		setEvent: '@?',
		eventId: '@?',
		lessonId: '=?',
		lesson: '=?',
		portfolioPageId: '=?',
		portfolioPage: '=?',
		contentModule: '=',
		position: '=',
	};

	public controller = ContentModuleController;
	public controllerAs = 'contentModuleControl';

	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/content-module.html';

	public static Factory() {
		var directive = ($timeout) => new this($timeout);
		directive.$inject = ['$timeout'];
		return directive;
	}

	//@ngInject
	constructor(private $timeout) {}
}

export { ContentModule };
